import Table from "react-bootstrap/Table";
import Form from "react-bootstrap/Form";
import _ from "lodash";
import * as ipoSelectors from "../../../../selectors/ipo";
import CustomEmptyFont from "../../../../components/CustomEmptyFont";
import Helper from "../../../../utils/Helper";
import clsx from "clsx";
import React, {useRef, useState} from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router";
import LoadingOverlay from "../../../../components/LoadingOverlay";
import EmptyItemView from "../../../../components/EmptyItemView";
import { useDispatch, useSelector } from "react-redux";
import * as ipoActions from "../../../../action/ipo";
import DeclarationModal from "../../model/Declaration";
import ImportantNoticeModal from "../../model/ImportantNotice";
import {
  getIPODetailFinalPricePerShare,
  getIPODetailPriceChanged,
  getIPODetailShouldDisable
} from "../../../../selectors/ipo";
import {Tooltip as ReactTooltip} from "react-tooltip";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowDown, faCircle} from "@fortawesome/free-solid-svg-icons";

function IPOListTableComponent({ data, loading = false, closeSelect = false }) {
  const tooltipsRef = useRef();
  const [showDeclaration, setShowDeclaration] = useState(false);
  const [showImportantNotice, setShowImportantNotice] = useState(false);
  const history = useHistory();
  const previousIPOID = useSelector((state) =>
    _.get(state, ["ipo", "data", "ipoID"]),
  );
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    getValues,
    setError,
    getFieldState,
    watch,
    reset,
    clearErrors,
  } = useForm({
    mode: "onTouched",
    reValidateMode: "onSubmit",
  });
  const dispatch = useDispatch();

  const ipoID = watch("ipo_id");
  const ipoTNC = watch("ipo_tnc");
  const onChangeIpo = (e) => {
    setValue("ipo_id", e.target.value);
  };

  const onSubmit = (values) => {
    if(!_.isEmpty(previousIPOID)){
      if(!_.isEqual(previousIPOID,values.ipo_id)){
        dispatch(ipoActions.removeIPODetail());

      }
    }
    history.push(`/dashboard/e-ipo/subscribe/${values.ipo_id}`);
  };

  const onError = () => {};

  return (
    <div className="ipo-table">
      <Form onSubmit={handleSubmit(onSubmit, onError)}>
        {!_.isEmpty(data) ? (
          <Table responsive="lg" className="ipo-table-content">
            <tr>
              {closeSelect ? false : <th></th>}
              <th style={{ minWidth: "160px" }}>Share Issue No</th>
              <th style={{ minWidth: "120px" }}>Share Name</th>
              <th style={{ minWidth: "140px" }}>Issuing House</th>
              <th style={{ minWidth: "120px" }}>Closing Date</th>
              <th style={{ minWidth: "120px" }}>Closing Time</th>
              <th style={{ minWidth: "120px" }}>Unit Price</th>
            </tr>
            {!_.isEmpty(data)
              ? _.map(data, (item, index) => {
                  const id = ipoSelectors.getIPODetailID(item);
                  const issueNo = ipoSelectors.getIPODetailIssueNo(item);
                  const stockName = ipoSelectors.getIPODetailStockName(item);
                  const pricePerShare =
                    ipoSelectors.getIPODetailPricePerShare(item);
                  const finalPricePerShare =
                      ipoSelectors.getIPODetailFinalPricePerShare(item);
                  const issueHouse = ipoSelectors.getIPODetailIssueHouse(item);
                  const timestamp =
                    ipoSelectors.getIPODetailCloseDatetimeTimestamp(item);
                  const closeNewDate = new Date(timestamp * 1000);
                  const shouldDisable = ipoSelectors.getIPODetailShouldDisable(item);
                  const priceChanged = ipoSelectors.getIPODetailPriceChanged(item);

                  return (
                    <tr
                        className={clsx({
                          ["disabled"]: shouldDisable,
                        })}
                        onMouseEnter={(e) => {
                          if (shouldDisable) {
                            tooltipsRef.current?.open({
                              position: {
                                x: e.clientX,
                                y: e.clientY,
                              },
                              place: "bottom",
                              content: "Non shariah stock",
                            });
                          }
                        }}
                        onMouseLeave={(e) => {
                          tooltipsRef.current?.close();
                        }}
                    >
                      {closeSelect ? (
                        false
                      ) : (
                        <td>
                          <Form.Check
                              className="input-large"
                            name="group1"
                            type="radio"
                            id={`reverse-${index}-1`}
                            value={id}
                            disabled={shouldDisable}
                            {...register(`ipo_selected`, {
                              onChange: (e) => onChangeIpo(e),
                            })}
                          />
                        </td>
                      )}
                      <td>
                        <CustomEmptyFont variant="span" value={issueNo} />
                      </td>
                      <td>
                        <CustomEmptyFont variant="span" value={stockName} />
                      </td>
                      <td>
                        <CustomEmptyFont variant="span" value={issueHouse} />
                      </td>
                      <td>
                        <CustomEmptyFont
                          variant="span"
                          value={Helper.formatDate(closeNewDate)}
                        />
                      </td>
                      <td>
                        <CustomEmptyFont
                          variant="span"
                          value={Helper.formatTime(closeNewDate)}
                        />
                      </td>
                      <td>
                        { priceChanged ? (
                              <FontAwesomeIcon icon={faArrowDown} className="text-success me-1" />
                          ) : false }
                        <CustomEmptyFont variant="span" value={priceChanged ? finalPricePerShare : pricePerShare} className={clsx(priceChanged ? "text-success" : '')} />
                      </td>
                    </tr>
                  );
                })
              : false}
          </Table>
        ) : (
          <Table responsive="lg" className="ipo-table-content">
            <tr>
              {closeSelect ? false : <th></th>}
              <th style={{ minWidth: "160px" }}>Share Issue No</th>
              <th style={{ minWidth: "120px" }}>Share Name</th>
              <th style={{ minWidth: "140px" }}>Issuing House</th>
              <th style={{ minWidth: "120px" }}>Closing Date</th>
              <th style={{ minWidth: "120px" }}>Closing Time</th>
              <th style={{ minWidth: "120px" }}>Unit Price</th>
            </tr>
            <tr>
              <td colSpan="100" className={clsx("text-center")}>
                <div className="position-relative">
                  <EmptyItemView extraCss={{ height: "20vh" }} />
                  <LoadingOverlay
                    loadingClass="loading-grey-bg"
                    loading={loading}
                  ></LoadingOverlay>
                </div>
              </td>
            </tr>
          </Table>
        )}
        {!closeSelect && !_.isEmpty(data) ? (
          <>
            <p className="ipo-important-notice-p">
              PLEASE CLICK AND READ THE{" "}
              <a
                  href="https://www.bursamalaysia.com/market_information/announcements/company_announcement?cat=IO&sub_type=IO3"
                  target="_blank"
              >
                PROSPECTUSES
              </a>
              , <a
                href="#"
                onClick={() => {
                  setShowImportantNotice(true);
                }}
            >IMPORTANT NOTICE</a> AND{" "}
              <a
                  href="#"
                  onClick={() => {
                    setShowDeclaration(true);
                  }}
              >
                DECLARATION
              </a>{" "}
              BEFORE SUBMITTING YOUR SHARE SUBSCRIPTION.
            </p>
            <Form.Check
                name="group2"
                type="radio"
                className="ipo-tnc-radio input-large"
                label={
                  <p className="ipo-tnc-p">
                  I HAVE READ AND AGREE WITH THE ABOVE DOCUMENTS
                </p>
              }
              required={true}
              id={`reverse-1`}
              {...register("ipo_tnc", {
                // required: "Please accept the terms and conditions"
              })}
            ></Form.Check>

            <div className="d-flex justify-content-center mt-4">
              <button
                className={clsx("btn custom-button-primary")}
                type="submit"
                disabled={_.isEmpty(ipoTNC) || _.isEmpty(ipoID)}
                style={{ backgroundColor: "#9D7905" }}
              >
                Submit
              </button>
            </div>
          </>
        ) : (
          false
        )}
      </Form>
      <DeclarationModal
          showModal={showDeclaration}
          setShowModal={setShowDeclaration}
      ></DeclarationModal>
      <ImportantNoticeModal
          showModal={showImportantNotice}
          setShowModal={setShowImportantNotice}
      ></ImportantNoticeModal>
      <ReactTooltip ref={tooltipsRef} className="tooltip-info" variant="info"></ReactTooltip>
    </div>
  );
}

export default IPOListTableComponent;
